(function() {
  // Prevent re-initialization if already loaded
  if (window.AccordionItemInitialized) return;
  window.AccordionItemInitialized = true;

  class AccordionItem {
    constructor(element) {
      this.container = element;
      this.button = this.container.querySelector('.component-accordion-item__title');
      this.content = this.container.querySelector('.component-accordion-item__content');
      this.isAnimating = false;
      
      // Store initial open state from HTML
      this.isOpen = this.container.classList.contains('is-open');
      
      this.init();
    }

    init() {
      this.button.addEventListener('click', () => {
        this.toggle();
      });
    }

    toggle() {
      if (this.isAnimating) return;
      
      if (this.isOpen) {
        this.close();
      } else {
        this.open();
      }
    }

    open() {
      this.isAnimating = true;
      this.isOpen = true;
      
      this.container.classList.add('is-open');
      this.button.setAttribute('aria-expanded', 'true');
      
      this.content.addEventListener('transitionend', () => {
        this.isAnimating = false;
      }, { once: true });
    }

    close() {
      this.isAnimating = true;
      this.isOpen = false;
      
      this.container.classList.remove('is-open');
      this.button.setAttribute('aria-expanded', 'false');
      
      this.content.addEventListener('transitionend', () => {
        this.isAnimating = false;
      }, { once: true });
    }
  }

  // Initialize all accordion items
  function initAccordionItems(container = document) {
    container.querySelectorAll('.component-accordion-item:not([data-accordion-initialized])').forEach(item => {
      item.setAttribute('data-accordion-initialized', 'true');
      new AccordionItem(item);
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    initAccordionItems();
  });

  // Re-initialize on Shopify section load (for theme editor)
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function(event) {
      initAccordionItems(event.target);
    });
  }

  // Expose init function globally for dynamic content
  window.initAccordionItems = initAccordionItems;
})();
